(function () {
  "use strict";

  const FALLBACK_SRC = "//www.americanstandard-us.com/cdn/shop/files/no-image-swatch.png?v=9561460259801808305";

  const FILES_BASE_PATH = (() => {
    const [withoutQuery] = FALLBACK_SRC.split("?");
    const lastSlashIndex = withoutQuery.lastIndexOf("/");
    return lastSlashIndex >= 0 ? withoutQuery.slice(0, lastSlashIndex + 1) : "";
  })();

  const EXACT_BLOCK_LIST = new Set([
    "charcoal-gray203",
    "0",
    "frosted-glass",
    "clear-glass",
    "white-heat",
    "tobacco",
    "brushed-satin",
    "bisque",
    "rough-chrome",
    "autumn-cherry",
    "nutmeg",
    "n-a",
    "taupe",
    "polished-brass",
    "black-on-white",
    "nickel",
  ]);

  const handleize = (value) => {
    if (!value && value !== 0) return "";
    return String(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  class ProductOptionValueComponent extends HTMLElement {
    constructor() {
      super();
      this._value = null;
      this._option = null;
      this._imageUrl = (x) => x;
    }

    static get observedAttributes() {
      return ["value", "option", "imageUrl"];
    }

    attributeChangedCallback(name, _oldValue, newValue) {
      if (newValue === _oldValue) return;
      if (name === "value") {
        this.value = newValue;
      } else if (name === "option") {
        this.option = newValue;
      } else if (name === "imageUrl") {
        this.imageUrl = newValue;
      }
    }

    get value() {
      return this._value;
    }

    set value(value) {
      this._value = value;
      this.render();
    }

    get option() {
      return this._option;
    }

    set option(option) {
      this._option = option;
      this.render();
    }

    get imageUrl() {
      return this._imageUrl;
    }

    set imageUrl(imageUrl) {
      this._imageUrl = imageUrl;
      this.render();
    }

    connectedCallback() {
      this.render();
    }

    render() {
      const optionHandle = handleize(this._option);
      const valueHandle = handleize(this._value);
      const valueLabel = this._value;

      if (!valueLabel) {
        this.replaceChildren();
        return;
      }

      const shouldFallback = this._shouldUseFallback(valueHandle);

      const img = document.createElement("img");
      img.width = 14;
      img.height = 14;
      img.loading = "lazy";
      img.alt = valueLabel;

      if (!shouldFallback && valueHandle) {
        const prefix =
          optionHandle === "finir" ? "swatch_-_finir_-_" : "swatch_-_color_-_";
        const fileName = `${prefix}${valueHandle}.png`;
        img.src = this._imageUrl(
          FILES_BASE_PATH ? `${FILES_BASE_PATH}${fileName}` : FALLBACK_SRC,
          "28x28"
        );
      } else {
        img.src = this._imageUrl(FALLBACK_SRC, "28x28");
      }

      img.onerror = () => {
        img.onerror = null;
        img.src = FALLBACK_SRC;
      };

      this.replaceChildren(img);
    }

    _shouldUseFallback(valueHandle) {
      if (!valueHandle) return true;
      if (valueHandle.includes("no-finish")) return true;
      return EXACT_BLOCK_LIST.has(valueHandle);
    }
  }

  customElements.define(
    "rcc-product-option-value",
    ProductOptionValueComponent
  );
})();
